import React from 'react';
import { Header } from './Header';
import { useAuthentication } from './LoginPage';
import { ShowIf } from '@apply/ui';

export const ThankYouPage: React.FC = () => {
    const { isRegisteredUser } = useAuthentication();

    return (
        <>
            <Header />
            <main>
                <h2>Thank you.</h2>
                <h3>Your application has been submitted successfully.</h3>
                <section
                    className='create-new-application'
                    style={{ padding: '0.5rem 1rem 1rem 1rem' }}
                >
                    <div>
                        Create a <a href='/borrower'>new application</a>
                    </div>
                </section>
                <ShowIf showIf={isRegisteredUser}>
                    <section
                        className='return-to-home-screen'
                        style={{ padding: '0 0 1rem 1rem' }}
                    >
                        <div>
                            List of your <a href='/home'>applications</a>
                        </div>
                    </section>
                </ShowIf>
            </main>
        </>
    );
};
